import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SourcifyCustomerQuoteDetailsApprovalLineItemKeys {
  itemSku = 'itemSku',
  Moq = 'Moq',
  productPackage = 'productPackage',
  sampleCost = 'sampleCost',
  sampleQty = 'sampleQty',
  samplingTime = 'samplingTime',
  toolingCost = 'toolingCost',
  samplingLeadTime = 'samplingLeadTime',
  qty = 'qty',
  size = 'size',
  weight = 'weight',
}

export const sourcifyCustomerQuoteDetailsApprovalFileDataSchema = yup.object().shape({
  quoteNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  buyer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  sample: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  warehouse: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemSku: yup.string().nullable().optional(),
        Moq: yup.string().nullable().optional(),
        productPackage: yup.string().nullable().optional(),
        sampleCost: yup.string().nullable().optional(),
        sampleQty: yup.string().nullable().optional(),
        samplingTime: yup.string().nullable().optional(),
        toolingCost: yup.string().nullable().optional(),
        samplingLeadTime: yup.string().nullable().optional(),
        qty: yup.string().nullable().optional(),
        size: yup.string().nullable().optional(),
        weight: yup.string().nullable().optional(),
      }),
    )
    .required(),
  instructions: yup.string().nullable().optional(),
})

export type SourcifyCustomerQuoteDetailsApprovalFileData = yup.InferType<
  typeof sourcifyCustomerQuoteDetailsApprovalFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<SourcifyCustomerQuoteDetailsApprovalFileData>

export const SourcifyCustomerQuoteDetailsApprovalFileMappings: RequiredFileData = {
  quoteNumber: '13c9e173-f9a5-466e-afdd-8c88daffeb4e',
  dateIssued: '958b37a3-37a5-47ca-83b1-325bd3dfd932',
  dateDue: '3482a44a-d04a-466c-b744-c999786f354c',
  paymentTerms: '73121f9b-7924-435f-954a-28434ccdbf46',
  freightTerms: 'b32ce1b3-c5a0-488c-b583-68916f71d518',
  buyer: {
    attn: 'df532b37-1e32-4380-8a4f-d986823e0804',
    companyName: '655e3411-7e78-4d43-9e4e-3b4e5dc86566',
    addressLine1: 'cda82588-45f6-4e38-94e2-80ca38ff52b1',
    addressLine2: '872508b5-446b-41ba-b63f-586594953a9a',
    city: '585cb6f1-c451-41ba-97f8-aac902039e8a',
    state: 'd8a2fff6-5fc3-405c-ab1f-d6443d5aaae2',
    zipCode: '99f8e04b-8d7f-426e-a814-a12cdd82f085',
    country: '3c1660b5-5b2c-48ef-8c51-fed035cea442',
    phoneNumber: '8ee77db9-fde5-484f-a61e-14a21f81f23d',
    emailAddress: 'fb8e3879-4fd3-465e-b6f4-96210167e9ab',
  },
  sample: {
    attn: 'a8ca2da8-46a2-49c4-af57-5325b4e432ab',
    companyName: 'cf1946c8-201b-4069-aea3-692d35bd3b6a',
    addressLine1: '3a752bcf-6cc4-4647-a61f-9ebcc6383ef1',
    addressLine2: '553892ea-4161-4aeb-9a24-eb6175846223',
    city: '3177c53d-59cb-423c-9488-187e33c26a41',
    state: 'a931cb4e-2383-4bec-ab61-e16a3baffd90',
    zipCode: '05e7b645-316d-413e-88a8-fe8d66bbe746',
    country: '1c31c521-070b-413d-bc22-f0eb8166e854',
    phoneNumber: '1d4b6a24-ac38-4f9f-a7e1-33e7e00de760',
    emailAddress: '60ca6a38-f74c-4218-84c2-2a080ef83076',
  },
  warehouse: {
    attn: 'd38e9e7b-5a0f-443c-a4b3-3431e207cc0a',
    companyName: 'e8a50d27-439e-435e-b627-d727939850d6',
    addressLine1: '3cfcf7ed-d542-4a2e-951a-802c575d9a3d',
    addressLine2: '684e90b7-9779-41b8-b13d-c9dc990b3b44',
    city: 'bd9efdc5-63eb-496d-bcba-8a6c3b0d5a8a',
    state: 'a8d16f00-f458-4da8-be1d-51273a6f98c1',
    zipCode: '9f8a397c-14ba-430c-9d60-713e022804f3',
    country: '2577d823-8b06-4c71-b0a6-b0834d160840',
    phoneNumber: '820f73c2-2ec7-4cb2-b985-b62462329e93',
    emailAddress: '359efcbf-1416-4853-b3ad-16b741379e31',
  },
  items: [
    {
      itemSku: 'ead28932-4221-404a-b997-b95ac1f6a33f',
      Moq: 'c7db84d9-fca6-425e-8e2b-d5cfdb634719',
      productPackage: '272c7e67-ccea-448a-908a-01ac27672094',
      sampleCost: '01fe2451-0de6-46fc-93be-0fefdfd94cef',
      sampleQty: 'f4b06237-42b7-4aeb-82fc-b9cf38739caa',
      samplingTime: '57f1c093-8824-4ca6-b36b-6261923297fc',
      toolingCost: '0f38ea1a-1f70-443d-87f0-3fa3d30ba7b7',
      samplingLeadTime: '70d43592-6483-49a3-b73a-f6ffaeb92a32',
      qty: 'a04dcecb-6f88-40ac-b3bd-055c1a2517a4',
      size: 'c427f4c9-7d35-4a53-9053-4abdd6798a9a',
      weight: 'ff5d3d7b-4982-4864-8646-ca6a9a972030',
    },
  ],
  instructions: '812125e8-13c5-474d-a6a8-874bfe3ddc64',
}
